
<template>
  <v-app>
    <v-content id="login" :bg="false">
      <vue-particles
        color="#000044"
        :particle-opacity="0.3"
        :particles-number="120"
        shape-type="circle"
        :particle-size="6"
        lines-color="#FFA000"
        :lines-width="2"
        :line-linked="true"
        :line-opacity="0.4"
        :lines-distance="100"
        :move-speed="3"
        :hover-effect="true"
        hover-mode="grab"
        :click-effect="true"
        click-mode="repulse"
      />
    </v-content>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4" lg="3">
          <v-alert v-model="showError" type="error" dismissible>
            {{ this.errormm }}
          </v-alert>
          <v-alert
            v-model="successBool"
            type="success"
            dismissible
            transition="scale-transition"
          >
            {{ this.successMsg }}
          </v-alert>

          <v-card class="elevation-9 pa-3" color="#ffffff">
            <v-card-text>
              <div class="layout column align-center">
                <img
                  src="../../../assets/D._S._Senanayake_College_crest.png"
                  alt="DUC logo"
                  width="120"
                  height="120"
                />
                <!-- <h1 class="flex my-4 primary--text">Login</h1> -->
                <v-row justify="center"
                  ><h2
                    style="line-height: 130%"
                    class="primary--text text-center"
                  >
                    D.S.Senanayake College Colombo 7
                  </h2></v-row
                >
                <v-row justify="center"
                  ><p class="text-center">
                    <br /><b>සේනානායකයින්ගේ අධ්‍යාපනික අත්වැල</b><br />
                    'තමාට පෙර රට' ආදර්ශය පෙරදැරි කරගත් කොළඹ ඩී.එස්. සේනානායක
                    විද්‍යාලයෙන් 2 ශ්‍රේණියේ සිට 11 ශ්‍රේණිය දක්වා පළමු වාර
                    ප්‍රශ්න පත්‍ර සිංහල, දමිළ සහ ඉංග්‍රීසි මාධ්‍ය
                    ත්‍රිත්වයෙන්... නියමිත කාලය තුළ පිළිතුරු සපයා, එසැණින් ඔබගේ
                    දැනුම මට්ටම මැන ගන්න....
                  </p>
                  <p class="text-center">
                    <b>சேனநாயக்க கல்வி வழிகாட்டி</b><br />
                    'தனக்கு முன் நாடு' உதாரணத்தைப் பின்பற்றி கொழும்பு டி.எஸ்
                    சேனாநாயக்க கல்லூரியிடமிருந்து சிங்களம், தமிழ் மற்றும் ஆங்கில
                    3 மொழிகளிலும் தரம் 2 முதல் தரம் 11 வரை முதலாம் தவணை
                    வினாத்தாள்கள்... சரியான நேரத்தில் பதில் கூறுங்கள் உங்கள்
                    அறிவின் அளவை நீங்களே மதிப்பிடுங்கள்.
                  </p></v-row
                >
              </div>
              <!-- <v-form>
                <v-text-field
                  v-model="email"
                  append-icon="email"
                  name="email"
                  label="E-mail"
                  type="email"
                />
                <v-text-field
                  id="password"
                  v-model="password"
                  append-icon="lock"
                  name="password"
                  label="Password"
                  type="password"
                  @keyup.enter.native="login"
                />
              </v-form> -->
            </v-card-text>
            <!-- <v-card-actions>
              <v-btn block color="primary" @click="login"> Login </v-btn>
            </v-card-actions>
            <v-card-actions />
            <v-card-actions>
              <v-btn block outlined color="red" @click="howTo">
                How to Signin ?
              </v-btn>
            </v-card-actions> -->
            <v-card-actions>
              <v-btn block color="success" @click="exams">
                Online Exams - 2021
              </v-btn>
            </v-card-actions>
            <!-- <a @click="reset">Reset Password</a> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
/* eslint-disable no-unused-vars */
import db from "./api/firebaseInit";
import firebase from "firebase";
import Vue from "vue";
import VueCookies from "vue-cookies";
import VueParticles from "vue-particles";
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);
Vue.use(VueParticles);
Vue.use(VueCookies);
export default {
  data: () => ({
    loading: false,
    email: "",
    password: "",
    showError: false,
    errormm: " ",
    successMsg: "",
    successBool: false,
  }),
  // watch: {
  //   loader () {
  //     const l = this.loader
  //     this[l] = !this[l]
  //     setTimeout(() => {
  //       this[l] = false
  //     }, 3000)
  //     this.loader = null
  //   },
  // },
  mounted() {
    // //console.log(VueCookies.isKey('user'));
    this.showError = false;
    this.successBool = false;
    if (VueCookies.isKey("user")) {
      // check if logged in
      this.$router.push("/");
    }
  },
  methods: {
    login: function (e) {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          (user) => {
            VueCookies.config("7d");
            this.showError = false;
            this.successMsg = "Login Success";
            this.successBool = true;
            const uid = firebase.auth().currentUser.uid;
            // console.log(uid)

            const userDetails = db
              .collection("userDetails")
              .doc(uid)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  e = doc.data().folderName;
                  VueCookies.set("user", uid);
                  VueCookies.set("folderID", e);
                  VueCookies.set("userEmail", this.email);
                  this.$router.push("/");
                } else {
                  this.successBool = false;
                  this.$alert("Contact Admin", "", "warning");
                  this.$router.push("/Login");
                }
              })
              .catch((err) => {
                const error = err;
                console.log("Error getting document", err);
              });
          },
          (err) => {
            // alert(err.message);
            // this.errormm = err.message
            // this.showError = true
            this.$alert(err.message, "", "error");
            this.$router.push("/Login");
          }
        );
      e.preventDefault();
    },
    exams: function (e) {
      this.$router.push("/exams");
    },
    reset: function (e) {
      this.$alert(
        "Can`t reset the password by yourselves. Contact Admin",
        "",
        "warning"
      );
      //   const auth = firebase.auth()
      //   const emailAddress = this.email
      //   //console.log(this.email)

      //   auth.sendPasswordResetEmail(emailAddress).then(() => {
      //     // Email sent.
      //     // //console.log('sent');
      //     // alert('Success! Please check your email inbox');
      //     this.$alert('Success!', 'Please check your email inbox', 'success')
      //   }).catch(err => {
      //     const error = err
      //     this.$alert('Error!', 'Please check your email', 'error')
      //   // //console.log('Error getting document', err);
      //   })
    },
    howTo: function (e) {
      this.$alert(
        "All usernames and passwords have been given to the class teachers. You can get your class credentials from your  class teacher",
        "",
        "success"
      );
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.centered-input input {
  text-align: center;
}
</style>
